import { api } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";

export const deleteManyQuoteRequestLine = async (ids: string[]) => {
  const response = await api.quoteRequestLines.deleteMany.mutation({
    body: { ids },
  });

  if (response.status !== 200) {
    throw new ApiError("Can't delete batch", response.status, response.body);
  }

  const { failedIds, deletedIds, quoteRequestId } = response.body;
  if (failedIds && failedIds.length > 0) {
    throw new Error(`Can't delete ${failedIds.length} quote request line(s) from the batch`);
  }

  return { deletedIds, quoteRequestId };
};
